import {BaseModel} from "@/model/Model";

export enum DingtalkTaskType {
    ASYNC_SEND_MESSAGE = "ASYNC_SEND_MESSAGE"
}

export interface DingtalkTaskResult {
}

export default class DingtalkTask extends BaseModel<DingtalkTask> {
    rawId!: number
    type!: DingtalkTaskType
    result!: DingtalkTaskResult
}
